<script setup lang="ts">
import { ref } from 'vue'

const STORAGE_KEY = 'avoschool-cookie-consent'
const visible = ref(false)

// Читаем согласие только на клиенте; SSR нет, но хранилище может быть недоступно
// в редких окружениях — поэтому через try/catch.
try {
  visible.value = localStorage.getItem(STORAGE_KEY) !== 'accepted'
} catch {
  visible.value = true
}

function accept() {
  try {
    localStorage.setItem(STORAGE_KEY, 'accepted')
  } catch {
    // Если localStorage недоступен — просто прячем баннер на сессию.
  }
  visible.value = false
}
</script>

<template>
  <Transition name="cookie">
    <aside v-if="visible" class="cookie-notice" role="dialog" aria-live="polite" aria-label="Уведомление об использовании cookie">
      <div class="cookie-notice__text">
        Мы используем cookie, чтобы сайт работал удобнее. Подробнее — в
        <RouterLink :to="{ name: 'policy' }">политике конфиденциальности</RouterLink>.
      </div>
      <VBtn size="small" variant="flat" class="cookie-notice__btn" @click="accept">
        Принять
      </VBtn>
    </aside>
  </Transition>
</template>
